// extracted by mini-css-extract-plugin
module.exports = {"OVOMFA":"styles__OVOMFA___YA3EG","OVOCallback":"styles__OVOCallback___1t8Bi"};